(function () {
  'use strict';

  function formatMoney(amount) {
    return amount.toFixed(2);
  }

  function openCartDrawer(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'build-your-set',
          data: { itemCount: cart ? cart.item_count : undefined, source: 'build-your-set' }
        }
      })
    );

    var cartDrawerComponent = document.querySelector('cart-drawer-component');
    if (cartDrawerComponent) {
      setTimeout(function () {
        if (typeof cartDrawerComponent.open === 'function') {
          cartDrawerComponent.open();
        } else if (!cartDrawerComponent.hasAttribute('open')) {
          cartDrawerComponent.setAttribute('open', '');
        }
      }, 50);
      return;
    }

    var legacyCartDrawer = document.querySelector('cart-drawer');
    if (legacyCartDrawer) {
      if (typeof legacyCartDrawer.renderContents === 'function' && cart) {
        legacyCartDrawer.renderContents(cart);
      }
      legacyCartDrawer.classList.remove('is-empty');
      if (typeof legacyCartDrawer.open === 'function') {
        legacyCartDrawer.open();
      } else {
        legacyCartDrawer.classList.add('active', 'is-open');
      }
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true, cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  function initCarousel(carouselEl) {
    var trackWrap = carouselEl.querySelector('[data-bys-track-wrap]');
    var track = carouselEl.querySelector('[data-bys-track]');
    var prevBtn = carouselEl.querySelector('[data-bys-prev]');
    var nextBtn = carouselEl.querySelector('[data-bys-next]');
    var slides = Array.prototype.slice.call(carouselEl.querySelectorAll('[data-bys-product]'));
    var index = 0;

    function visibleCount() {
      return window.matchMedia('(min-width: 750px)').matches ? 3 : 2;
    }

    function maxIndex() {
      return Math.max(0, slides.length - visibleCount());
    }

    function getOffset(i) {
      if (!slides.length) return 0;
      var wrapWidth = trackWrap.getBoundingClientRect().width;
      var cols = visibleCount();
      return i * (wrapWidth / cols);
    }

    function update(animate) {
      if (!slides.length) return;
      if (animate === false) {
        track.classList.add('no-transition');
        track.style.transform = 'translateX(-' + getOffset(index) + 'px)';
        track.getBoundingClientRect(); // force reflow
        track.classList.remove('no-transition');
      } else {
        track.style.transform = 'translateX(-' + getOffset(index) + 'px)';
      }
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
    }

    prevBtn.addEventListener('click', function () {
      index = Math.max(0, index - 1);
      update();
    });

    nextBtn.addEventListener('click', function () {
      index = Math.min(maxIndex(), index + 1);
      update();
    });

    // ---- Swipe (touch only) ----
    var dragState = null;

    function onTouchStart(e) {
      dragState = {
        startX: e.touches[0].clientX,
        moved: false,
        currentOffset: 0
      };
    }

    function onTouchMove(e) {
      if (!dragState) return;
      var dx = e.touches[0].clientX - dragState.startX;
      dragState.currentOffset = dx;
      if (Math.abs(dx) > 4) dragState.moved = true;
      if (Math.abs(dx) > 8) e.preventDefault();
    }

    function onTouchEnd() {
      if (!dragState) return;
      var dx = dragState.currentOffset;
      var threshold = 50;
      if (dragState.moved && Math.abs(dx) > threshold) {
        if (dx < 0) {
          index = Math.min(maxIndex(), index + 1);
        } else {
          index = Math.max(0, index - 1);
        }
      }
      dragState = null;
      update();
    }

    trackWrap.addEventListener('touchstart', onTouchStart, { passive: true });
    trackWrap.addEventListener('touchmove', onTouchMove, { passive: false });
    trackWrap.addEventListener('touchend', onTouchEnd);

    window.addEventListener('resize', function () { update(false); });

    update();

    return { update: update };
  }

  function buildSizePills(slideEl, role, onSelect) {
    var sizesEl = slideEl.querySelector('[data-bys-sizes]');
    if (!sizesEl) return;

    var raw = slideEl.getAttribute('data-variants') || '[]';
    var variants;
    try { variants = JSON.parse(raw); } catch (e) { variants = []; }

    // Single variant with title "Default Title" → no size pills needed
    if (variants.length === 1 && variants[0].title === 'Default Title') {
      sizesEl.hidden = true;
      return;
    }

    sizesEl.innerHTML = '';

    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bys__size-btn' + (v.available ? '' : ' is-soldout');
      btn.textContent = v.title;
      btn.disabled = !v.available;
      btn.setAttribute('data-variant-id', v.id);
      btn.setAttribute('data-price', v.price);
      btn.setAttribute('data-title', v.title);

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        sizesEl.querySelectorAll('.bys__size-btn').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        onSelect(role, slideEl, v);
      });

      sizesEl.appendChild(btn);
    });

    sizesEl.hidden = false;
  }

  function initSection(section) {
    var carousels = Array.prototype.slice.call(section.querySelectorAll('[data-bys-carousel]'));
    carousels.forEach(initCarousel);

    // state: top/bottom → { productId, variantId, price, title, image, available, size }
    var state = { top: null, bottom: null };

    var totalEl      = section.querySelector('[data-bys-total]');
    var addBtn       = section.querySelector('[data-bys-add-btn]');
    var addBtnText   = section.querySelector('[data-bys-add-btn-text]');
    var errorEl      = section.querySelector('[data-bys-error]');
    var currencySymbol = (totalEl.textContent.trim().split(' ')[0]) || '';
    var addBtnDefaultLabel = addBtnText.textContent;

    var selectionEmptyEl = section.querySelector('[data-bys-selection-empty]');
    var selectionGridEl  = section.querySelector('[data-bys-selection-grid]');

    function refreshTotal() {
      var DISCOUNT = 8;
      var total = 0;
      if (state.top)    total += parseFloat(state.top.price);
      if (state.bottom) total += parseFloat(state.bottom.price);
      if (state.top && state.bottom) {
        var discounted = total - DISCOUNT;
        totalEl.innerHTML = '<s style="opacity:0.45">' + currencySymbol + ' ' + formatMoney(total) + '</s> &nbsp;' + currencySymbol + ' ' + formatMoney(discounted);
      } else {
        totalEl.textContent = currencySymbol + ' ' + formatMoney(total);
      }
    }

    function refreshSelectionPreview() {
      var bothSelected = !!(state.top && state.bottom);
      if (bothSelected) {
        ['top', 'bottom'].forEach(function (role) {
          var data = state[role];
          var img  = section.querySelector('[data-bys-selected-img="' + role + '"]');
          var name = section.querySelector('[data-bys-selected-name="' + role + '"]');
          var size = section.querySelector('[data-bys-selected-size="' + role + '"]');
          img.src = data.image;
          img.alt = data.title;
          name.textContent = data.title;
          size.textContent = data.size ? data.size : '';
        });
        selectionGridEl.hidden = false;
        selectionEmptyEl.hidden = true;
      } else {
        selectionGridEl.hidden = true;
        selectionEmptyEl.hidden = false;
      }
    }

    function refreshAddButton() {
      var ready = state.top && state.bottom &&
                  state.top.variantId && state.bottom.variantId &&
                  state.top.available === true && state.bottom.available === true;
      addBtn.disabled = !ready;
    }

    // Called when the user clicks a card (selects the product)
    function selectProduct(role, slideEl) {
      var carousel  = slideEl.closest('[data-bys-carousel]');
      var allSlides = carousel.querySelectorAll('[data-bys-product]');

      // Deselect all slides in this carousel, hide their size pickers
      allSlides.forEach(function (s) {
        s.classList.remove('is-selected');
        var sz = s.querySelector('[data-bys-sizes]');
        if (sz) {
          sz.querySelectorAll('.bys__size-btn').forEach(function (b) {
            b.classList.remove('is-selected');
          });
        }
      });

      slideEl.classList.add('is-selected');

      // Reset state for this role (no size chosen yet)
      state[role] = {
        productId: slideEl.getAttribute('data-product-id'),
        variantId: null,   // will be set after size selection
        price: parseFloat(slideEl.getAttribute('data-price')) || 0,
        title: slideEl.getAttribute('data-title'),
        image: slideEl.getAttribute('data-image'),
        available: false,  // requires size to be chosen
        size: null
      };

      // Build / show size pills for this slide
      buildSizePills(slideEl, role, onSizeSelect);

      refreshSelectionPreview();
      refreshTotal();
      refreshAddButton();
      errorEl.hidden = true;
    }

    // Called when the user clicks a size pill
    function onSizeSelect(role, slideEl, variant) {
      if (!state[role]) return;
      state[role].variantId = String(variant.id);
      state[role].price     = parseFloat(variant.price) || state[role].price;
      state[role].available = variant.available === true || variant.available === 'true';
      state[role].size      = variant.title;

      refreshSelectionPreview();
      refreshTotal();
      refreshAddButton();
    }

    // Wire card clicks
    carousels.forEach(function (carousel) {
      var role = carousel.getAttribute('data-role');
      carousel.querySelectorAll('[data-bys-select]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          // Ignore if this was a drag
          var slideEl = btn.closest('[data-bys-product]');
          selectProduct(role, slideEl);
        });
      });
    });

    // Add to cart
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      if (!state.top || !state.bottom) return;

      addBtn.disabled = true;
      addBtnText.textContent = 'Adding...';
      errorEl.hidden = true;

      var payload = {
        items: [
          { id: state.top.variantId,    quantity: 1 },
          { id: state.bottom.variantId, quantity: 1 }
        ]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error((err && err.description) || 'Could not add items to cart');
            });
          }
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          addBtnText.textContent = 'Added!';
          openCartDrawer(cart);
          setTimeout(function () {
            addBtnText.textContent = addBtnDefaultLabel;
            addBtn.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          addBtnText.textContent = addBtnDefaultLabel;
          addBtn.disabled = false;
        });
    });

    refreshAddButton();
    refreshSelectionPreview();
  }

  function init() {
    document.querySelectorAll('.bys').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target.querySelector('.bys');
    if (section) initSection(section);
  });
})();